<template>
    <v-container
        class="align-start mt-6"
    >
        <v-row
            class="align-self-center"
            align="center"
            justify="center"
        >
            <v-col
                v-if="!userSettings.referral_program_enabled && $_user.can_post_offers"
                cols="12"
                class="mb-10"
            >
                <v-alert
                    color="#D2CFDD"
                    class="rounded-xl"
                >
                    <v-card-title>
                        <h2 class="font-weight-medium">
                            Refer and Earn a Percentage
                        </h2>
                    </v-card-title>

                    <v-card-text>
                        <p>
                            Introducing the new referral feature in the Kaoshi app! Now, you can easily
                            invite your friends and family to join Kaoshi Network and earn a referral fee for
                            each successful referral. It's simple - just share your unique referral link or
                            code with your contacts, and when they sign up as a poster and complete a
                            transaction, you'll receive 2.5% of the transaction fee as a referral fee. Not
                            only will you be helping your friends and family discover a convenient and
                            reliable P2P currency marketplace, but you'll also be rewarded for doing so.
                            Start referring today and see your earnings grow!
                        </p>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                            color="primary white--text px-4"
                            rounded
                            @click="showReferAndEarnModal = true"
                        >
                            Join Referral Program
                        </v-btn>
                    </v-card-actions>
                </v-alert>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <TotalReferredAmount
                    v-if="userSettings.referral_program_enabled"
                    :total-referred-amount="totalReferredAmount"
                />

                <v-card-actions>
                    <v-btn
                        v-if="userSettings.referral_program_enabled"
                        class="primary white--text px-4"
                        @click="showWithdrawModal = true"
                    >
                        Withdraw
                    </v-btn>
                    <v-btn
                        class="primary white--text px-4"
                        @click="showUserInviteModal = true"
                    >
                        Invite
                    </v-btn>
                </v-card-actions>
            </v-col>
            <v-col></v-col>
            <v-col></v-col>
        </v-row>

        <v-tabs
            v-if="userSettings.referral_program_enabled"
            v-model="tab"
            background-color="transparent"
            class="mt-8"
            grow
        >
            <v-tab>Referrals</v-tab>
            <v-tab>Activity</v-tab>
            <v-tab>About/Guidelines</v-tab>
        </v-tabs>

        <v-tabs-items
            v-model="tab"
            class="transparent pt-8"
        >
            <v-tab-item>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="searchText"
                            label="Search"
                            hide-details
                            clearable
                            outlined
                            dense
                        />
                    </v-col>
                    <v-col
                        cols="3"
                        class="ml-auto"
                    >
                        <v-select
                            v-model="filterExtendedStatus"
                            :items="statuses"
                            label="Status Filter"
                            hide-details
                            clearable
                            outlined
                            dense
                        />
                    </v-col>
                </v-row>

                <v-data-iterator
                    :items="filteredInvitedUsers"
                    item-key="id"
                    :items-per-page="-1"
                    :loading="loading"
                    hide-default-footer
                >
                    <template #default="{ items }">
                        <v-row>
                            <v-col
                                v-for="item in items"
                                :key="item.id"
                                cols="12"
                            >
                                <v-card
                                    class="bordered-card py-4 px-2"
                                    elevation="0"
                                    outlined
                                >
                                    <v-row class="align-center text-no-wrap">
                                        <v-col
                                            cols="1"
                                            class="grey--text text--darken-1"
                                        >
                                            Name:
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="text-truncate ellipsis"
                                        >
                                            {{ item.email }}
                                        </v-col>
                                        <v-col
                                            cols="1"
                                            class="grey--text text--darken-1"
                                        >
                                            Status:
                                        </v-col>
                                        <v-col cols="2">
                                            <InvitedUserStatusChip :value="item.extendedStatus" />
                                        </v-col>
                                        <v-col
                                            cols="1"
                                            class="grey--text text--darken-1"
                                        >
                                            Date:
                                        </v-col>
                                        <v-col cols="2">
                                            {{ getLastEventDate(item) }}
                                        </v-col>
                                        <v-col cols="2">
                                            <v-btn
                                                v-if="!item.joined_at"
                                                color="primary white--text"
                                                depressed
                                                rounded
                                                @click="reinviteUser(item)"
                                            >
                                                Resend
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-iterator>

                <v-pagination
                    v-model="pagination.page"
                    :length="pagination.pageCount"
                    class="mt-4"
                />
            </v-tab-item>

            <v-tab-item>
                <RefTxTab />
            </v-tab-item>

            <v-tab-item>
                <div class="content">
                    <p>
                        Introducing the new referral feature in the Kaoshi app! Now, you can easily invite your friends and family to join Kaoshi Network and earn a referral fee for each successful referral. It's simple - just share your unique referral link or code with your contacts, and when they sign up as a poster and complete a transaction, you'll receive 2.5% of the transaction fee as a referral fee. Not only will you be helping your friends and family discover a convenient and reliable P2P currency marketplace, but you'll also be rewarded for doing so. Start referring today and see your earnings grow!
                    </p>

                    <p>
                        <router-link :to="{ name: 'referral-terms' }">
                            Terms . Privacy
                        </router-link>
                    </p>
                </div>
            </v-tab-item>
        </v-tabs-items>

        <ReferAndEarnModal
            v-model="showReferAndEarnModal"
        />

        <UserInviteModal
            v-model="showUserInviteModal"
        />

        <WithdrawModal
            v-model="showWithdrawModal"
            :total-amount="totalReferredAmount[0]"
        />
    </v-container>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable import/no-extraneous-dependencies */
import { mapGetters } from 'vuex';
import { filter, debounce } from 'lodash';

import InvitedUser from '../models/InvitedUser';

import InvitedUserStatusChip from './components/invited-user-status-chip.vue';
import RefTxTab from './referral/RefTxTab.vue';
import TotalReferredAmount from './referral/TotalReferredAmount.vue';
import ReferAndEarnModal from './referral/ReferAndEarnModal.vue';
import UserInviteModal from './referral/UserInviteModal.vue';
import WithdrawModal from './referral/WithdrawModal.vue';

export default {
    components: {
        RefTxTab,
        TotalReferredAmount,
        InvitedUserStatusChip,
        ReferAndEarnModal,
        UserInviteModal,
        WithdrawModal,
    },
    data: () => ({
        tab: 0,
        searchText: '',
        loading: false,
        email: '',
        statuses: [
            {
                text: 'Invited',
                value: { extendedStatus: 'invited' },
            },
            {
                text: 'Registered',
                value: { extendedStatus: 'registered' },
            },
            {
                text: 'Transacted - Posted',
                value: { extendedStatus: 'transacted-posted' },
            },
            {
                text: 'Transacted - Matched',
                value: { extendedStatus: 'transacted-matched' },
            },
            {
                text: 'Transacted - Completed',
                value: { extendedStatus: 'transacted-completed' },
            },
        ],
        filterExtendedStatus: null,
        invitedUsers: [],
        pagination: {
            page: 1,
            pageSize: 10,
        },
        totalReferredAmount: [],
        showReferAndEarnModal: false,
        showUserInviteModal: false,
        showWithdrawModal: false,
    }),
    computed: {
        ...mapGetters([
            'userSettings',
        ]),
        filteredInvitedUsers() {
            if (this.filterExtendedStatus) {
                return filter(this.invitedUsers, this.filterExtendedStatus);
            }
            return this.invitedUsers;
        },
    },
    watch: {
        'pagination.page': {
            immediate: true,
            handler: 'listInvitedUser',
        },
        searchText: 'debouncedListInvitedUser',
    },
    mounted() {
        this.getTotalReferredAmount();
    },
    methods: {
        async getTotalReferredAmount() {
            try {
                const { data } = await Vue.backendApi()
                    .referralTransactions()
                    .getTotalAmount();
                this.totalReferredAmount = data;
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Error fetching invited users',
                    text: error,
                });
            }
        },

        async reinviteUser(user) {
            try {
                this.loading = true;
                const { email } = user;

                // eslint-disable-next-line no-undef
                await Vue.backendApi()
                    .inviteUser({ email });

                this.$swal({
                    type: 'success',
                    title: 'User invited!',
                    text: 'Click okay to continue',
                });
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Error inviting user',
                    text: error,
                });
            } finally {
                this.listInvitedUser();
                this.loading = false;
            }
        },

        async listInvitedUser() {
            try {
                this.loading = true;

                const { searchText: search } = this;

                const params = {
                    ...this.pagination,
                    search,
                };

                const { data: { data, pagination } } = await Vue.backendApi()
                    .user(this.$_user.id)
                    .getInvitedUsers(params);

                this.invitedUsers = data.map((user) => new InvitedUser(user));
                this.pagination = pagination;
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Error fetching invited users',
                    text: error,
                });
            } finally {
                this.loading = false;
            }
        },

        // eslint-disable-next-line func-names
        debouncedListInvitedUser: debounce(function () {
            this.listInvitedUser();
        }, 500),

        getLastEventDate(user) {
            const {
                last_transaction_created_at,
                joined_at,
                created_at,
            } = user;

            return this.$options.filters.date(last_transaction_created_at
                || joined_at
                || created_at);
        },
    },
};
</script>

<style scoped>
.bordered-card.v-card {
    background-color: #D2CFDD;
    border-color: #000000;
}
</style>
